const displayModal = (state = [], action) => {
    switch(action.type){
        case "SET_DISPLAY":
            return  action.payload
        case "DELETE_DISPLAY":
            return {
                type:"",
                value:""
            }
        default:
            return state
    }
}

export default displayModal;